export default __webpack_public_path__ + "7b34a0f7d38e89b01e75ec15e3f7d407.png";